import React from "react";
import { typeColor, typeLabel } from "@/constants/options";

export function TypeTag({ type, className = "" }) {
  return (
    <span
      className={`brut-tag ${className}`}
      style={{ backgroundColor: typeColor(type), color: "#0A0A0A" }}
      data-testid={`type-tag-${type}`}
    >
      {typeLabel(type)}
    </span>
  );
}

export function YearTag({ year, className = "" }) {
  return (
    <span
      className={`brut-tag bg-white ${className}`}
      data-testid={`year-tag-${year}`}
    >
      Y{year}
    </span>
  );
}
